import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import AuthService from '../AuthService';
import User from './User';
import AuthenticateChildren from '../AuthenticateChildren';
import { urls } from '../urls';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    logout = () => AuthService.getInstance().logout()

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/"><img src="/peptalkr-logo.png" alt="Peptalkr" /></NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <AuthenticateChildren roles={urls.router.clients.index.roles}>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to={urls.router.clients.index.url}>Clients</NavLink>
                                    </NavItem>
                                </AuthenticateChildren>
                                <AuthenticateChildren roles={urls.router.logs.index.roles}>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to={urls.router.logs.index.url}>Logs</NavLink>
                                    </NavItem>
                                </AuthenticateChildren>
                                <AuthenticateChildren roles={urls.router.chores.index.roles}>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to={urls.router.chores.index.url}>Chores</NavLink>
                                    </NavItem>
                                </AuthenticateChildren>
                                <AuthenticateChildren roles={urls.router.notificationchores.index.roles}>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to={urls.router.notificationchores.index.url}>SMS</NavLink>
                                    </NavItem>
                                </AuthenticateChildren>
                                <AuthenticateChildren roles={urls.router.transactionalchores.index.roles}>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to={urls.router.transactionalchores.index.url}>Emails</NavLink>
                                    </NavItem>
                                </AuthenticateChildren>
                                <User />
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js